import { render, staticRenderFns } from "./data-access-toggle.vue?vue&type=template&id=45f5b0ae&scoped=true&"
import script from "./data-access-toggle.vue?vue&type=script&lang=js&"
export * from "./data-access-toggle.vue?vue&type=script&lang=js&"
import style0 from "./data-access-toggle.vue?vue&type=style&index=0&id=45f5b0ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5b0ae",
  null
  
)

component.options.__file = "data-access-toggle.vue"
export default component.exports